import type { AppInventoryOptionType } from '@openx/types/targeting/appInventory.ts';
import { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent.ts';
import type { ComparisonType } from '@openx/types/targeting/targetingValuesTypes.ts';
import { removeWhiteSpaces } from '@openx/utils/lib/removeWhiteSpaces.ts';
import type { AnyAction } from '@reduxjs/toolkit';
import type { TFunction } from 'i18next';
import type { Dispatch, SetStateAction } from 'react';
import { setComparisonOpValue } from '../../../shared/InventoryAndContent/inventoryHelpers.ts';

export type ProcessManualInputProps = {
  value: string;
  comparisonType: ComparisonType;
  contentOption: InventoryContentOption | AppInventoryOptionType;
  inventoryContentOptions: string[];
  inventoryListItems: string[];
  setErrorText: Dispatch<SetStateAction<string>>;
  dispatchInventory: (action: AnyAction) => void;
  t: TFunction;
};

export const processManualInput = ({
  value,
  comparisonType,
  contentOption,
  inventoryContentOptions,
  inventoryListItems,
  setErrorText,
  dispatchInventory,
  t,
}: ProcessManualInputProps): boolean => {
  value = value.trim();

  if (contentOption === InventoryContentOption.PAGE_URL) {
    value = removeWhiteSpaces(value);
  }

  const alreadyExists = [...inventoryContentOptions, ...inventoryListItems].includes(value);
  const isEmpty = value === '';

  if (alreadyExists) {
    setErrorText(t('This item is already on the list.'));
    return false;
  }

  if (isEmpty) {
    setErrorText(t('This field cannot be empty.'));
    return false;
  }

  dispatchInventory({
    payload: { comparisonType, values: [...inventoryContentOptions, value] },
    type: setComparisonOpValue[contentOption],
  });
  setErrorText('');

  return true;
};
